import ScaniaLogo from "./assets/logo-scania.png";

const IS_LOCAL = process.env.NODE_ENV === 'none';
const BOT_NAME = process.env.NODE_ENV === 'production' ? 'scania' : 'scania';
const isProduction = process.env.NODE_ENV === 'production';
const HTTP_BASE = IS_LOCAL ? 'http://' : 'https://'
const BASE_URL = isProduction ? `${BOT_NAME}` : `staging.${BOT_NAME}`
const URL = IS_LOCAL ? `localhost:8445` : `${BASE_URL}.elife.com.br`

export default {
  agent: {
    displayName: "Assistente virtual",
    avatarUri: ScaniaLogo,
    description: "Tire dúvidas sobre nosso atendimento, serviços, produtos e muito mais. Se precisar, também temos atendentes apostos para te auxiliar em outras questões."
  },
  app: {
    websocket: `wss://${URL}/websocket/client/:session_id`,
    gateway: `${HTTP_BASE}${URL}/dialog/interact/`,
    cancel: `${HTTP_BASE}${URL}/dialog/attendances`,
    muted: true, // <- mute microphone at start
    start_suggestions: [], // <- array of suggestions, displayed at the start screen
    fallback_lang: "pt" // <- fallback language code, if history mode or network is unavailable
  },
  i18n: {
    pt: {
      defaultSuggestions: ["Menu inicial", "Atendimento"],
      callToAction: "Começar",
      welcomeTitle: "Boas vindas!",
      cancel: ["Reativar Assistente Virtual"],
      muteTitle: "Alterar acessibilidade",
      inputTitle: "Digite sua mensagem",
      sendTitle: "Enviar",
      microphoneTitle: "Falar"
    }
  }
};
